import { colors } from '../../../theme/color-palette';
export const tileStyles = {
	card: {
		width: '450px',
		border: `1px solid ${colors.LIST_BORDER_CLR}`,
		borderRadius: 8,
		height: '136px',
	},
	cardContent: {
		padding: '12px 16px',
	},
	subtitle: {
		color: `${colors.LIST_CLR}`,
		fontWeight: 400,
		fontSize: '14px',
		lineHeight: '20px',
	},
	mainValue: {
		fontSize: '24px',
		fontWeight: 700,
		lineHeight: '32px',
	},
	comparisonSection: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	comparisonText: {
		color: `${colors.MAKO}`,
	},
	columnOne: {
		width: '157px',
	},
	columnTwo: {
		display: 'flex',
		justifyContent: 'flex-end',
		flexGrow: 1,
	},
	columnThree: {
		flexGrow: 1,
		display: 'flex',
		justifyContent: 'flex-end',
	},
	detailText: {
		color: `${colors.MAKO}`,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		maxWidth: '157px',
	},
	changeText: {
		fontSize: '14px',
		fontWeight: 700,
		lineHeight: '20px',
		display: 'flex',
	},
	icon: {
		paddingTop: '2px',
	},
};
